<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex sm3>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="issueNo"
              label="Issue No"
              type="text"
              class="ml-1"
              v-model="queryParams.issueNo"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="description"
              label="Description"
              type="text"
              class="ml-1"
              v-model="queryParams.description"
            ></v-text-field>
          </v-flex>
          <v-flex sm3 v-if="showStatusFlag">
            <v-select
              label="Status..."
              :items="statusList"
              item-text="label"
              item-value="value"
              v-model="queryParams.status"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch()">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex sm12 class="mt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="productionPlanList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td @click="dialogClose(props.item)">
                  <a>{{ props.item.issueNo }}</a>
                </td>
                <td>
                  {{
                    props.item.issueDateInMilliSeconds | format-ms-date
                  }}
                </td>
                <td>{{ props.item.description }}</td>
                <td>{{ props.item.status }}</td>
                <td>
                  {{
                    props.item.updatedDateInMilliSeconds
                      | format-ms-date-time
                  }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
  
  <script>
import { productionPlanService } from "../../services/production-plan-service";

export default {
  name: "ProductionPlanDialog",
  props: {
    showDialog: Boolean,
    showStatusFlag: Boolean,
    params: Object,
  },
  data: () => ({
    showListLoading: false,
    queryParams: {
      fromDate: "",
      toDate: "",
      issueNo: "",
      description: "",
      status: "DRAFT",
      shopId: "",
      warehouseId: "",
      departmentId: "",
      isAddDetails: false,
      isAddUnits: false,
    },
    headers: [
      { text: "Issue No", align: "left", value: "issueNo" },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Description", value: "description" },
      { text: "Status", value: "status" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    productionPlanList: [],
    warehouseList: [],
    statusList: [
      { label: "---ALL---", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "PENDING", value: "PENDING" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
  }),
  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getProductionPlanList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams = { ...this.params };
          this.productionPlanList = [];
          this.getProductionPlanList();
        }
      },
    },
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductionPlanList();
    },
    getProductionPlanList() {
      if (!this.showListLoading) {
        this.showListLoading = true;
        let order = this.pagination.descending ? "desc" : "asc";
        productionPlanService
          .getProductionPlanList(
            this.queryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.productionPlanList = res.data.productionPlanList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },
    dialogClose(productionPlan) {
      this.$emit("close", productionPlan);
    },
  },
};
</script>
  